import gql from 'graphql-tag';

export const UPDATE_DASHBOARD_FILTER = gql`
  mutation updateDashboardFilter($filter: DashboardFilterInput!, $orderBy: [String], $pagination: DashboardPaginationInput) {
    updateDashboardFilter(filter: $filter, orderBy: $orderBy, pagination: $pagination) @client
  }
`;
